import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import RamSvg from '../../../assets/icons/app/ram.svg?raw';

export const RamIcon = (props) => <CustomSVG svg={RamSvg} preserveColors appIconSmall {...props} />;
